import React from 'react';
import useMedia from 'use-media';
import MainPageDesktop from './mainPageDesktop';
import MainPageMobile from './mainPageMobile';

function MainPage() {
    const isLargeScreen = useMedia('(min-width: 601px)');
    const isSmallScreen = useMedia('(max-width: 600px)');
    return (
        <div>
            {isLargeScreen && <MainPageDesktop isLargeScreen={isLargeScreen} isSmallScreen={false} />}
            {isSmallScreen && <MainPageMobile isLargeScreen={false} isSmallScreen={isSmallScreen}/>}
        </div>
    )
}

export default MainPage;